// ─────────────────────────────────────────────────────────────────────────────
// BRANDING — single source of truth (CLAUDE.md rule 7).
//
// Public name FINAL as of 2026-08-16: "SKOHR" — all-caps wherever the name is
// displayed; domain and email addresses lowercase (skohr.app). Client decision;
// factory decisions.md. Every user-facing name, the PWA short name, and the
// domain live HERE. Do NOT hard-code the app name anywhere else.
//
// Rule 7 also forbids "NRL" in the PUBLIC-facing name / manifest. Internal repo
// names, code, comments and data references to the NRL competition are fine.
// ─────────────────────────────────────────────────────────────────────────────

export const branding = {
  /** User-facing display name shown in the app UI. */
  appName: "SKOHR",
  /** PWA short_name (home-screen label; keep short, no "NRL"). */
  pwaShortName: "SKOHR",
  /** PWA name (install prompt / splash). */
  pwaName: "SKOHR",
  /** Store/marketing one-liner. */
  description: "Check in to the games you attend live. Earn XP, badges and collectible cards.",
  /** Primary domain (no protocol). */
  domain: "skohr.app",
  /** PWA theme + background colours (match the prototype's light theme). */
  themeColor: "#41ab80",
  backgroundColor: "#f7f9f6",
} as const;

export type Branding = typeof branding;
